import useSWR from "swr";

import { fetchPresignedDownloadUrl } from "@common/utils/presignedDownload";
import { localImageUrl } from "@common/utils/local-image-urls";
import { useFetchApi } from "./useFetchApi";

const STORED_IMAGE_URL_QUERY = "stored-image-url";

export interface StoredImageRef {
  storageUrl: string;
  fileName: string;
}

export interface StoredImageUrl {
  imageUrl: string | undefined;
  isUnavailable: boolean;
}

export function useStoredImageUrl(storedImage: StoredImageRef): StoredImageUrl {
  const { fetchWeb } = useFetchApi();
  const pastedImageUrl = localImageUrl(storedImage.storageUrl);
  const { data: presignedImageUrl, error } = useSWR(
    pastedImageUrl ? null : [STORED_IMAGE_URL_QUERY, storedImage.storageUrl, storedImage.fileName],
    ([, storageUrl, fileName]: string[]) => fetchPresignedDownloadUrl((path) => fetchWeb(path), storageUrl, fileName),
    { revalidateOnFocus: false, shouldRetryOnError: false },
  );
  if (pastedImageUrl) return { imageUrl: pastedImageUrl, isUnavailable: false };
  return { imageUrl: presignedImageUrl, isUnavailable: error !== undefined };
}
